export default class SearchForm {
	constructor(urlParams) {
		this.containerElement = document.querySelector('.search-bar')

		if (!this.containerElement) {
			console.warn(`Could not find search form (Selector: ${elementSelector})`)

			return
		}

		this.urlParams = urlParams

		this.toggleElement = this.containerElement.querySelector('.toggle')
		this.openToggleElement = this.toggleElement.querySelector('.open-toggle')
		this.closeToggleElement = this.toggleElement.querySelector('.close-toggle')
		this.formElement = this.containerElement.querySelector('form')
		this.inputElement = this.formElement.querySelector('input[type="text"]')
		this.searchButtonElement = this.formElement.querySelector('button[type="submit"]')
		this.topbarElement = document.querySelector('.topbar')
		this.topbarMenuElement = document.querySelector('.top-bar-menu--secondary')
		this.topbarStationsMenuElement = document.querySelector('.topbar__stations')

		this.onToggleClickEvent = this.onToggleClick.bind(this)
		this.onSubmitFormEvent = this.onSubmitForm.bind(this)

		this.toggleElement.addEventListener('click', this.onToggleClickEvent)
		this.formElement.addEventListener('submit', this.onSubmitFormEvent)

		this.isToggleOpen = false

		// const currentUrl = new URL(window.location.href);
		// const searchQuery = currentUrl.pathname.split('/')[2];

		this.previousSearchInputValue = null // searchQuery || null
	}

	onToggleClick(e) {
		if (this.isToggleOpen) {
			this.closeSearchBar()
		} else {
			this.openSearchBar()
		}
	}

	openSearchBar() {
		this.containerElement.classList.add('show');

		// this.formElement.classList.add('show')

		if (this.topbarMenuElement) {
			this.topbarMenuElement.classList.add('hide')
		}

		// this.openToggleElement.classList.remove('show')
		// this.closeToggleElement.classList.add('show')

		if (this.topbarElement) {
			this.topbarElement.classList.add('topbar--search-bar-open')
		}

		if (this.topbarStationsMenuElement) {
			this.topbarStationsMenuElement.classList.add('hide')
		}

		// Set focus on input
		const endPosition = this.inputElement.value.length

		this.inputElement.setSelectionRange(endPosition, endPosition)
		this.inputElement.focus()
		
		this.isToggleOpen = true
	}

	closeSearchBar() {
		this.containerElement.classList.remove('show');

		// this.formElement.classList.remove('show')

		if (this.topbarMenuElement) {
			this.topbarMenuElement.classList.remove('hide')
		}

		// this.openToggleElement.classList.add('show')
		// this.closeToggleElement.classList.remove('show')

		if (this.topbarElement) {
			this.topbarElement.classList.remove('topbar--search-bar-open')
		}

		if (this.topbarStationsMenuElement) {
			this.topbarStationsMenuElement.classList.remove('hide')
		}

		this.isToggleOpen = false
	}

	onSubmitForm(e) {
		e.preventDefault();

		const searchInputValue = this.inputElement.value

		if (searchInputValue && (this.previousSearchInputValue === null || searchInputValue !== this.previousSearchInputValue)) {
			this.previousSearchInputValue = searchInputValue

			window.location.href = `/search/${encodeURIComponent(searchInputValue)}`
		}
	}

	enablesearchButtonElement() {
		this.searchButtonElement.setAttribute('disabled', false)
	}

	disablesearchButtonElement() {
		this.searchButtonElement.setAttribute('disabled', true)
	}
}
